import React, { useEffect, useState } from "react";
import { usePagination } from "../../shared/hooks/use-pagination";
import ReactTablePagination from "../../components/task-list/components/pagination";
import ReactTable from "react-table";
import { useSearchUsers } from "../../shared/hooks/api/use-search-users";
import { buildUserColumns } from "./lib/constants";
import { useNavigate } from "react-router-dom";
import { getStorageValue, setStorageValue } from "shared/storage";

const UsersIndex = () => {
    const navigate = useNavigate();
    const storedSettings = getStorageValue("users-list-settings") || {};
    const [usersList, setUsersList] = useState([]);
    const [
        { pageNumber, pageSize, sortBy, totalCount, totalPages, searchParams, pagingParams, filteredValues },
        { setPageSize, setPage, setSortBy, setTotalCount, search },
    ] = usePagination({
        defaultValues: {
            pageSize: storedSettings.pageSize || 10,
        },
        filterOutputMappings: {
            firstName: "firstNames",
            lastName: "lastNames",
            email: "emails",
            teams: "assignmentGroups",
        },
        callback: () => {
            setUsersList([]);
        },
    });
    const { data: searchResult, isLoading, mutate: searchUsers, isSuccess } = useSearchUsers();

    useEffect(() => {
        searchUsers({ searchParams, pagingParams });
    }, [searchParams, pagingParams]);

    useEffect(() => {
        if (isSuccess) {
            setUsersList(searchResult.items);
            setTotalCount(searchResult.totalRecordCount);
        }
    }, [isSuccess, searchResult]);

    useEffect(() => {
        setStorageValue("users-list-settings", { pageSize: pageSize });
    }, [pageSize]);

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleRowClick = (s, rowInfo) => {
        return {
            onDoubleClick: () => {
                const url = `/admin/user/${rowInfo.original.userId}`;
                navigate(url);
            },
        };
    };

    return (
        <div>
            <h1>Users</h1>
            <ReactTable
                manual
                data={usersList}
                filtered={filteredValues}
                sortable
                columns={buildUserColumns()}
                minRows={usersList.length > 0 ? 1 : 3}
                totalRecords={totalCount}
                showPagination
                PaginationComponent={ReactTablePagination}
                onPageChange={handlePageChange}
                onPageSizeChange={setPageSize}
                onSortedChange={setSortBy}
                onFilteredChange={search}
                sorted={sortBy}
                page={pageNumber}
                pageSize={pageSize}
                pages={totalPages}
                loading={isLoading}
                getTrProps={handleRowClick}
            />
        </div>
    );
};

export default UsersIndex;
